export const CREATE_MANUAL_RECORD_SUCCESS = 'CREATE_MANUAL_RECORD_SUCCESS';
export const CREATE_MANUAL_RECORD_ERROR = 'CREATE_MANUAL_RECORD_ERROR';

export const DELETE_MANUAL_RECORD_SUCCESS = 'DELETE_MANUAL_RECORD_SUCCESS';
export const DELETE_MANUAL_RECORD_ERROR = 'DELETE_MANUAL_RECORD_ERROR';

export const UPDATE_MANUAL_RECORD_SUCCESS = 'UPDATE_MANUAL_RECORD_SUCCESS';
export const UPDATE_MANUAL_RECORD_ERROR = 'UPDATE_MANUAL_RECORD_ERROR';

export const MANUAL_RECORD_FORM_ID = 'manualRecordForm';
export const PREVIOUS_MANUAL_RECORDS_FORM_ID = 'previousManualRecordsForm';

export const PREVIEW_IMAGE_WIDTH_AND_HEIGHT = 100;
